import React, { useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@material-ui/core";
import { Container } from "@material-ui/core";
import { Grid, Paper} from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { TextField } from "@material-ui/core";
import { useFormik } from "formik";
import * as yup from 'yup';

//component
import Loader from "../components/Loader";
import TokenFormComponent from "../components/TokenFormComponent";

//action
import { get_purchase_list } from "../actions/purchaseAction";
import { token_create } from "../actions/purchaseAction";

const useStyles = makeStyles((theme) => ({
    button:{
        color: 'black',
        backgroundColor: theme.palette.primary['300'],
        '&:hover':{
            backgroundColor:theme.palette.primary['400']
        }    
    },
    container:{
        backgroundColor: 'white',
        borderRadius: '5px'
    },
    root:{
        [theme.breakpoints.up('xs')]:{
            margin: theme.spacing(1,1,15,1)
        },
        [theme.breakpoints.up('sm')]:{
            margin:theme.spacing(2,2,15,2)
        },
        [theme.breakpoints.up('md')]:{
            margin: theme.spacing(3,15,15,15)
        }
    },
    title:{
        fontWeight: 'bold'
    }
}))

const phoneRegex =/^[0-9]{2,3}?[0-9]{3,4}?[0-9]{3,4}?$/

const validationSchema = yup.object({
    phone_number: yup
        .string(20, '20文字以内で入力して下さい')
        .required('電話番号の入力は必須です')
        .matches(phoneRegex, '正しい形式で入力して下さい'),
    email: yup
        .string('Eメールアドレスを入力して下さい')
        .email('正しい形式で入力して下さい') 
        .required('emailアドレスは必須です'),
})

function AppraisalStatusScreen(){
    const classes = useStyles()
    const dispatch = useDispatch()

    const {accountInfo} = useSelector(state => state.account)
    const {loading, purchase, error} = useSelector(state => state.purchaseList)
    const {token_loading, token, token_error} = useSelector(state => state.oneTimeCode)

    const formik = useFormik({
        initialValues: {
            email:'',
            phone_number: ''
        },
        validationSchema,
        onSubmit: async (values) => {
            const data = {
                'email': values.email,
                'phone_number': values.phone_number
            }
            dispatch(token_create(data))
        }
    })

    useEffect(() => {
        //purchaseの情報とアイテム一覧の取得を行うようにする
        if(accountInfo){
            dispatch(get_purchase_list(accountInfo.id))
        }
    },[accountInfo, dispatch])

    //査定状況で画面切り替えを行う
    return(
        <>
        {
            accountInfo ?
            loading ?
            <div className={classes.loader}>
                <Loader/>
            </div>
            :
            error ?
            <div className={classes.root}>
                <Typography variant="h1" component="h1" className={classes.title}>
                    査定状況
                </Typography>
                <Container className={classes.container} maxWidth="md">
                    <Typography variant="h3" component="h3" className={classes.title}>
                        買取申し込み頂いた履歴がございません。
                    </Typography>
                </Container>
            </div>
            :
            purchase ?
            <div className={classes.root}>
                <Typography variant="h1" component="h1" className={classes.title}>
                    査定状況
                </Typography>
                <Container className={classes.container} maxWidth="md">
                    <Grid container spacing={3} direction="column">
                        {purchase.map((history) => (
                            <Grid item key={history.id}>
                                <Paper className={classes.card} elevation={0}>
                                    <Typography variant="subtitle1" component="p" >
                                        {`査定番号: ${history.identifier}`}
                                    </Typography>
                                    <Typography variant="subtitle1" component="p">
                                        {`受付日時: ${history.created_at}`}
                                    </Typography>
                                    <Typography variant="subtitle1" component="p">
                                        {`ステータス: ${history.state}`}
                                    </Typography>
                                    <Button className={classes.button}>
                                        詳細
                                    </Button>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </div>
            :
            <div className={classes.root}>
                <Typography variant="h1" component="h1" className={classes.title}>
                    査定状況
                </Typography>
                <Container className={classes.container} maxWidth="md">
                    <Typography variant="h3" component="h3" className={classes.title}>
                        買取申し込み頂いた履歴がございません。
                    </Typography>
                </Container>
            </div>
            :
            token_loading ?
                <div className={classes.loader}>
                    <Loader/>
                </div>
            :
            token_error ?
            <div className={classes.root}>
            <Typography variant="h1" component="h1" className={classes.title}>
                査定状況
            </Typography>
            <Container className={classes.container} maxWidth="md">
                <Typography variant="h3" component="h3" className={classes.title}>
                    買取申し込み頂いた履歴がございません。
                </Typography>
            </Container>
            </div>
            :
            token ?
            token.is_used ?
            <div className={classes.root}>
                <Typography variant="h1" component="h1" className={classes.title}>
                    査定状況
                </Typography>
                <Container className={classes.container} maxWidth="md">
                    <Grid container spacing={3} direction="column">
                        {purchase.map((history) => (
                            <Grid item key={history.id}>
                                <Paper className={classes.card} elevation={0}>
                                    <Typography variant="subtitle1" component="p" >
                                        {`査定番号: ${history.identifier}`}
                                    </Typography>
                                    <Typography variant="subtitle1" component="p">
                                        {`受付日時: ${history.created_at}`}
                                    </Typography>
                                    <Typography variant="subtitle1" component="p">
                                           {`ステータス: ${history.state}`}
                                    </Typography>
                                    <Button className={classes.button}>
                                        詳細
                                    </Button>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </div>
            :
            <>
            {/*発行されたtokneの認証を行う*/}
            <TokenFormComponent/>
            </>
            :
            <Container className={classes.container} maxWidth="md">
            {/*emailと電話番号で認証を行う*/}
                <form onSubmit={formik.handleSubmit}>
                    <Grid container spacing={2} direction="column">
                        <Grid item>
                            <TextField
                                fullWidth
                                id="email"
                                name="email"
                                label="メールアドレス"
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                error={formik.touched.email && Boolean(formik.errors.email)}
                                helperText={formik.touched.email && formik.errors.email}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                fullWidth
                                id="phone_number"
                                name="phone_number"
                                label="電話番号"
                                value={formik.values.phone_number}
                                onChange={formik.handleChange}
                                error={formik.touched.phone_number && Boolean(formik.errors.phone_number)}
                                helperText={formik.touched.phone_number && formik.errors.phone_number}
                            />
                        </Grid>
                        <Grid item>
                            <Button 
                            className={classes.button} 
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            >
                                送信する
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Container>
        }
        </>

    )
}

export default AppraisalStatusScreen